import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/event/")({
    component: EventsReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportEvent],
        showInSideMenu: false,
        label: "pages.report.event.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.report.event.title"),
        };
    },
});

function EventsReportPage() {
    return (
        <TenantPage headerNavigationItems={getReportHeaderItems}>
            <></>
        </TenantPage>
    );
}
